"use client";

import { CommunitySearchInput } from "./CommunitySearchInput";

interface ShopProductFilterBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export function ShopProductFilterBar({
  searchQuery,
  onSearchChange,
}: ShopProductFilterBarProps) {
  return (
    <div className="bg-panel/80 backdrop-blur-sm pt-2 pb-6">
      <CommunitySearchInput
        inputId="shop-product-search"
        value={searchQuery}
        onChange={onSearchChange}
        placeholder="Search products..."
        size="sm"
      />
    </div>
  );
}
